import axios from 'axios'

let realtimeUrl = null,
  manager = null,
  realtime = null;

if (process.env.NODE_ENV == 'production') {
  realtimeUrl = `wss://rlt.joineta.com`;

  manager = axios.create({
    baseURL: `https://mgr.joineta.com`,
    timeout: 5000,
    withCredentials: false,
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    }
  });

  realtime = axios.create({
    baseURL: `https://rlt.joineta.com`,
    timeout: 5000,
    withCredentials: false,
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    }
  });
} else {
  realtimeUrl = `wss://rlt.joineta.com`;

  manager = axios.create({
    baseURL: `https://mgr.joineta.com`,
    timeout: 5000,
    withCredentials: false,
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    }
  });

  realtime = axios.create({
    baseURL: `https://rlt.joineta.com`,
    timeout: 5000,
    withCredentials: false,
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    }
  });
}

export {
  manager,
  realtime,
  realtimeUrl,
  axios
};
